// extracted by mini-css-extract-plugin
module.exports = {"upper-row":"_93444fe79c--upper-row--rigr_","lower-row":"_93444fe79c--lower-row--Oag8x"};